var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "relative rounded-lg shadow-sm bg-white",
      class: {
        "border border-gray-200": !_vm.plan.most_popular,
        "border-2 border-primary-600": _vm.plan.most_popular,
      },
    },
    [
      _vm.plan.most_popular
        ? _c("div", { staticClass: "absolute inset-x-0 top-0 transform" }, [
            _vm._m(0),
          ])
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "divide-y divide-gray-200 flex flex-col h-full" },
        [
          _c("div", { staticClass: "pt-8 pb-6 px-6 flex flex-col sm:h-76" }, [
            _c("div", { staticClass: "flex-grow" }, [
              _c(
                "h2",
                { staticClass: "text-lg leading-6 font-medium text-gray-900" },
                [
                  _vm._v(
                    "\n                    " +
                      _vm._s(_vm.plan.name) +
                      "\n                "
                  ),
                ]
              ),
              _vm._v(" "),
              _c("p", { staticClass: "mt-4 text-sm leading-5 text-gray-500" }, [
                _vm._v(
                  "\n                    " +
                    _vm._s(_vm.plan.description) +
                    "\n                "
                ),
              ]),
            ]),
            _vm._v(" "),
            _c("p", { staticClass: "mt-8" }, [
              _c(
                "span",
                {
                  staticClass:
                    "text-4xl leading-10 font-extrabold text-gray-900",
                },
                [_vm._v("£" + _vm._s(_vm.price))]
              ),
              _vm._v(" "),
              _c(
                "span",
                {
                  staticClass: "text-base leading-6 font-medium text-gray-500",
                },
                [_vm._v("/" + _vm._s(_vm.period))]
              ),
            ]),
            _vm._v(" "),
            _c(
              "a",
              {
                staticClass:
                  "mt-8 w-full text-center bg-primary-600 border border-primary-600 rounded-md py-2 text-sm leading-5 font-semibold text-white hover:bg-primary-500 focus:outline-none focus:shadow-outline-gray transition duration-150 ease-in-out",
                attrs: {
                  href: _vm.route("customer.membership.billing", {
                    plan: _vm.plan.id,
                  }),
                },
              },
              [
                _vm._v(
                  "\n                Buy " +
                    _vm._s(_vm.plan.name) +
                    "\n            "
                ),
              ]
            ),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "pt-6 pb-8 px-6 flex-grow" }, [
            _c(
              "h3",
              {
                staticClass:
                  "text-xs leading-4 font-medium text-gray-900 tracking-wide uppercase",
              },
              [_vm._v("What's included")]
            ),
            _vm._v(" "),
            _c(
              "ul",
              { staticClass: "mt-6 space-y-4" },
              _vm._l(_vm.plan.highlights, function (highlight) {
                return _c("li", { staticClass: "flex space-x-3" }, [
                  _c(
                    "svg",
                    {
                      staticClass: "flex-shrink-0 h-5 w-5 text-green-500",
                      attrs: {
                        "aria-hidden": "true",
                        xmlns: "http://www.w3.org/2000/svg",
                        viewBox: "0 0 20 20",
                        fill: "currentColor",
                      },
                    },
                    [
                      _c("path", {
                        attrs: {
                          "fill-rule": "evenodd",
                          d: "M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z",
                          "clip-rule": "evenodd",
                        },
                      }),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "span",
                    { staticClass: "text-sm leading-5 text-gray-500" },
                    [
                      _vm._v(
                        "\n                        " +
                          _vm._s(highlight.text) +
                          "\n                    "
                      ),
                    ]
                  ),
                ])
              }),
              0
            ),
          ]),
        ]
      ),
    ]
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "div",
      { staticClass: "flex justify-center transform -translate-y-1/2" },
      [
        _c(
          "span",
          {
            staticClass:
              "inline-flex rounded-full bg-primary-600 px-4 py-1 text-sm leading-5 font-semibold tracking-wider uppercase text-white",
          },
          [_vm._v("\n              Most popular\n            ")]
        ),
      ]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }